export default __webpack_public_path__ + "assets/images/3.2de3b9.avif";